import request from '@/utils/request'

let CommerceApi = {

  /*商会列表*/
  list(data) {
    return request._post('/shop/plus.commerce.Index/index', data);
},

/*添加商会*/
add(data) {
    return request._post('/shop/plus.commerce.Index/add', data);
},
/*修改商会*/
edit(data) {
    return request._post('/shop/plus.commerce.Index/edit', data);
},
/*删除商会*/
del(data) {
    return request._post('/shop/plus.commerce.Index/del', data);
},
/*商会详情*/
detail(data) {
  return request._post('/shop/plus.commerce.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.commerce.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.commerce.Setting/getSetting', data, errorback);
    },
}
export default CommerceApi;



// WEBPACK FOOTER //
// ./src/api/commerce.js